import { CloseIcon, StatusCheckIcon } from '@/icons';
import { numericPart, type ToolType } from '@/components/ToolsPage/toolData';
import styles from '@/components/ToolsPage/ToolSavedModal.module.css';

interface SavedTool {
  readonly type: ToolType | '';
  readonly diameter: string;
  readonly toolLength?: string;
  readonly helix: string;
  readonly flute: string;
}

interface ToolSavedModalProps {
  readonly mode: 'edit' | 'define';
  readonly no: string;
  readonly tool: SavedTool;
  readonly onClose: () => void;
}

export function ToolSavedModal({ mode, no, tool, onClose }: ToolSavedModalProps): JSX.Element {
  const specs: readonly (readonly [string, string])[] = [
    ['Tool Type', tool.type || '—'],
    ['Ø (mm)', tool.diameter ? `${numericPart(tool.diameter)} mm` : '—'],
    ['Tool L. (mm)', tool.toolLength ? `${numericPart(tool.toolLength)} mm` : '—'],
    ['Helix Lenght', tool.helix ? `${numericPart(tool.helix)} mm` : '—'],
    ['Flue Count', tool.flute || '—'],
    ['Offset Lenght', '52.350'],
  ];

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-label="Tool Saved Successfully"
      onClick={onClose}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <span className={styles.title}>Tool Saved Succesfully</span>
          <button className={styles.close} onClick={onClose} type="button" aria-label="Close">
            <CloseIcon width={20} height={20} />
          </button>
        </div>

        <div className={styles.check}>
          <span className={styles.checkGlow} />
          <StatusCheckIcon width={64} height={64} className={styles.checkIcon} />
        </div>

        <div className={styles.headline}>
          <span className={styles.toolNo}>Tool {no}</span>
          <span className={styles.sub}>has been {mode === 'edit' ? 'updated' : 'added'}.</span>
        </div>

        <div className={styles.specList}>
          {specs.map(([label, value]) => (
            <div key={label} className={styles.specRow}>
              <span className={styles.specLabel}>{label}</span>
              <span className={styles.specValue}>{value}</span>
            </div>
          ))}
        </div>

        <button type="button" className={styles.closeBtn} onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
